<template>
    <div class="DispatchMassMessage container-fluid">

        <!--CREATE NEW TRANSACTION-->
        <b-modal ref="modal-component" size="lg" title="Dispatch Mass Message" hide-footer>
            <b-container>
                <b-form @submit="SaveRecord">
                    <b-row>
                        <b-col>
                            <h4>Message Info</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Text Message ({{SMSCharactersRemaining}} characters remaining, Est. Cost {{CalculateEstimatedCost}}):</label>
                                <textarea required rows="6" v-model="TargetRecord.SMSMessageBody" class="form-control" maxlength="500"></textarea>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Send copy of Text message to the following (enter 10 digit phone numbers, separated by commas):</label>
                                <textarea rows="4" v-model="TargetRecord.AdditionalSMSRecipients" class="form-control"></textarea>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Email Message:</label>
                                <p class="red">Mass Email Messaging is not available at this time.</p>
                                <!--<textarea required rows="6" v-model="TargetRecord.EmailMessageBody" class="form-control"></textarea>-->
                            </div>
                        </b-col>
                        <b-col>
                            <div class="form-group">
                                <label>Send copy of the Email to the following recipients:</label>
                                <p class="red">Mass Email Messaging is not available at this time.</p>
                                <!--<textarea rows="4" v-model="TargetRecord.AdditionalEmailRecipients" class="form-control"></textarea>-->
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h4>Selected Youth</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <table class="table-utility">
                                <thead>
                                    <tr>
                                        <th>Youth Name</th>
                                        <th>Location</th>
                                        <th>Program</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="youth in SelectedYouth">
                                        <td>{{youth.ClientName}}</td>
                                        <!--<td>
                                            <b-form-checkbox :value="true" v-model="contact.EmailCheckedStatus" size="lg"></b-form-checkbox>
                                        </td>-->
                                        <td>{{youth.City}}</td>
                                        <td>{{youth.Designation}}</td>
                                        <td>
                                            <span v-if="youth.Phone" :class="{ red: youth.Phone && youth.Phone.length != 13 }">{{youth.Phone}}</span>
                                            <span v-if="youth.IsOptInForTextMessaging != true" class="red">
                                                <br />NOT OPTED IN FOR TEXTS
                                            </span>
                                        </td>
                                        <td>{{youth.Email}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <p>Pressing <span class="bold">DISPATCH MESSAGES</span> will send a text messages to the recipients selected above.  If this window closes and you do not get an error message, then the messages have been sent.</p>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                DISPATCH MESSAGES
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';

    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMobileRetro } from '@fortawesome/free-solid-svg-icons';
    library.add(faMobileRetro);
    import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
    library.add(faEnvelope);

    
    export default {
        name: "DispatchMassMessage",
        created() {
 
        },
        props: [],
        data: function () {
            return {
                TargetRecord: {},
                SelectedYouth: [],
                //AUX
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
            };
        },
        methods: {
            //API
            SaveRecord(e) {
                e.preventDefault();

                this.$MasterAPI.ExecuteRequest("POST", "TAY/MassMessages", this.TargetRecord, this.SaveRecordSuccess, () => { }, true);
            },
            SaveRecordSuccess(response) {
                //this.$emit("updatetable");
                this.HideModal();
            },
            //UI
            ShowModal(selectedYouth) {
                let vm = this;
                vm.TargetRecord = {
                    SMSMessageBody: "",
                    AdditionalSMSRecipients: "",
                    ClientSubProgramMembershipIDs: []
                };
                vm.SelectedYouth = selectedYouth;
                selectedYouth.forEach(function (youth) {
                    if (youth.Phone && youth.Phone.length == 13 && youth.IsOptInForTextMessaging) {
                        vm.TargetRecord.ClientSubProgramMembershipIDs.push(youth.Id);
                    }
                });
                this.$refs['modal-component'].show();
            },
            HideModal() {
                this.$refs['modal-component'].hide();
            },
            //AUX
            formatDate(value, fmt = 'MM/DD/YY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            vSelect
        },
        computed: {
            SMSCharactersRemaining: function () {
                if (this.TargetRecord.SMSMessageBody) {
                    let initialCount = 500 - this.TargetRecord.SMSMessageBody.length;
                    if (initialCount < 0) {
                        return 0;
                    } else {
                        return initialCount;
                    }
                } else {
                    return 500;
                }
            },
            CalculateEstimatedCost: function () {
                if (this.TargetRecord.SMSMessageBody) {
                    let setsOf160 = Math.ceil(this.TargetRecord.SMSMessageBody.length / 160);
                    let additionalRecipientCount = this.TargetRecord.AdditionalSMSRecipients.split(',').length;
                    let totalCost = setsOf160 * (this.TargetRecord.ClientSubProgramMembershipIDs.length + additionalRecipientCount) * 0.01

                    const formatter = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    });

                    // Format the amount
                    return formatter.format(totalCost);
                } else {
                    return "N/A";
                }
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
</style>